import { useMutation } from "@tanstack/react-query";
import { DataOrParams, POST } from "../services/requests";
import { ENDPOINTS } from "../constants/endpoints";

export const useCreateProfile = () => {
  const mutation = useMutation({
    mutationFn: async (payload: DataOrParams) => {
        const {userId, token, ...restPayload} = payload;

        if(!token || !userId) {
          const data = await POST(`${ENDPOINTS.completeRegistration}`, {...restPayload});
          return data;
        }

        const data = await POST(`${ENDPOINTS.completeRegistration}?token=${token}&userId=${userId}`, {...restPayload});
        return data;
    }
  });

  return { ...mutation };
};
